import { createApiClient } from '@wix/premium-fed-sdk/@apis-infra-react';
import { UpgradeRecommendationQueriesConfig } from './upgrade-recommendation.queries';
export const UpgradeRecommendationApiClient = createApiClient(UpgradeRecommendationQueriesConfig);
//# sourceMappingURL=upgrade-recommendation.api-client.js.map